import { useEffect, useState } from 'react'

export const createGlobals = (initialState: any) => {
  let globalState = initialState
  const listeners = Object.fromEntries(Object.keys(initialState).map(key => [key, new Set()]))

  const setGlobalState = (key: string, nextValue: any) => {
    if (typeof nextValue === 'function') {
      globalState = { ...globalState, [key]: nextValue(globalState[key]) };
    } else {
      globalState = { ...globalState, [key]: nextValue };
    }
    listeners[key].forEach((listener: any) => listener())
  }

  const useGlobalState = (key: string) => {
    const [state, setState] = useState(globalState[key])
    useEffect(() => {
      const listener = () => {
        setState(globalState[key])
      }
      listeners[key].add(listener)
      listener() // in case it's already changed
      return () => {listeners[key].delete(listener)} // cleanup
    }, [])
    return [state, (nextValue: any) => setGlobalState(key, nextValue)]
  }

  return {
    setGlobalState,
    useGlobalState,
  }
}